import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class MonnaieService {
  url = `${environment.apiUrl}`;
  authUrl = `${environment.authUrl}`;
  siteUrl = `${environment.siteUrl}`;

  constructor(private http: HttpClient) { }

  /*==============================
get transactions
================================*/
  getTransactions(payload: any) {
    return this.http.post(`${this.authUrl}/frontoffice/transactions`, payload, {
      observe: "response",
    });
  }
  /*==============================
get balance
================================*/
  getBalance() {
    return this.http.get(`${this.authUrl}/frontoffice/prestataire-balance`, {
      observe: "response",
    });
  }

  /*==============================
get Card Type 
================================*/
  getAccountLinkingUrl() {
    return this.http.get(`${this.authUrl}/frontoffice/onboard-provider`, {
      observe: "response",
    });
  }
  getProviderBalance() {
    return this.http.post(`${this.authUrl}/frontoffice/get-provider-balance`, {
      observe: "response",
    });
  }
  balanceTransactions(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/balance-transactions`,
      payload,
      {
        observe: "response",
      }
    );
  }
  payout(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/prestataire/payout`,
      payload,
      {
        observe: "response",
      }
    );
  }
  createConnectedAccounts(payload: any) {
    return this.http.post(
      `${this.url}/connected_account`,
      payload,
      {
        observe: "response",
      }
    );
  }
  checkout(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/stripe/payout-to-bank`,
      payload,
      {
        observe: "response",
      }
    );
  }
  acceptStripeTos(payload: any) {
    return this.http.post(
      `${this.url}/accept-stripe-tos`,
      payload,
      {
        observe: "response",
      }
    );
  }
  stripeWithdrawAmount(payload: any) {
    return this.http.post(
      `${this.url}/provider/withdraw`,
      payload,
      {
        observe: "response",
      }
    );
  }
  stripeRedirectOnboarding(id: any, userId: any) {
    return `${this.url}/stripe/onboarding/${id}/${userId}`
  }
}
